import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import HomePage from './pages/HomePage';
import AnalyzerPage from './pages/AnalyzerPage';
import IOTypesPage from './pages/IOTypesPage';
import ThesaurusPageNew from './pages/ThesaurusPageNew';
import ConceptPage from './pages/ConceptPage';
import CategoryPage from './pages/CategoryPage';
import AdminPageFull from './pages/AdminPageFull';
import StatisticsPage from './pages/StatisticsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <div className="min-h-screen bg-gray-50">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/analyzer" element={<AnalyzerPage />} />
            <Route path="/io-types" element={<IOTypesPage />} />
            <Route path="/thesaurus" element={<ThesaurusPageNew />} />
            <Route path="/concept/:conceptId" element={<ConceptPage />} />
            <Route path="/category/:categoryId" element={<CategoryPage />} />
            <Route
              path="/statistics"
              element={
                <ProtectedRoute>
                  <StatisticsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminPageFull />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
